module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-greyville-black.9015e0d9.svg";